import Vue from 'vue'
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
// 引入路由
import router from './router';
// 引入进度条
import NProgress from 'nprogress';
import 'nprogress/nprogress.css'
// 引入高德地图
import AMap from 'vue-amap';
// 引入裁切组件
import VueCropper from 'vue-cropper'
// 引入请求
import {
	apiurl,
	post
} from './utils/http';
// 引入全局组件
import globalComponents from '@/utils/globalComponents'

Vue.config.productionTip = false;
Vue.prototype.$post = post;
Vue.prototype.$apiUrl = apiurl;
Vue.prototype.$initAMap = false; //全局地图初始化
Vue.prototype.$formatDay = function(date){
	if (date != null) {
		date = new Date(date);
		var y = date.getFullYear();
		var m = date.getMonth() + 1;
		m = m < 10 ? '0' + m : m;
		var d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		return y + '-' + m + '-' + d;
	}
	return "";
}

// 使用高德地图
Vue.use(AMap);
// 使用element UI
Vue.use(ElementUI);
// 使用裁切组件
Vue.use(VueCropper);
// 使用全局组件
Vue.use(globalComponents);

// 执行进度条
NProgress.configure({
	easing: 'ease', // 动画方式    
	speed: 500, // 递增进度条的速度    
	showSpinner: false, // 是否显示加载ico    
	trickleSpeed: 200, // 自动递增间隔    
	minimum: 0.3 // 初始化时的最小百分比
});

// 路由拦截器
router.beforeEach((to, from, next) => {
	console.log("路由", to);
	NProgress.start();
	document.title = (to.meta.title) ? to.meta.title : "佳智代驾";
	if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
		if (Boolean(localStorage.getItem("_JIAZHI_token"))) {
			next();
		} else {
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			});
		}
	} else {
		next();
	}
});

router.afterEach(() => {
	// 在即将进入新的页面组件前，关闭掉进度条
	NProgress.done();
});

// 初始化vue-amap
AMap.initAMapApiLoader({
	// 高德key
	key: '8ab8b01a620dbfd5cd7ec1fcb73f2946',
	plugin: ['AMap.Marker', 'AMap.Polyline', 'AMap.PolyEditor'],
	v: '1.4.10'
});

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
